export default __webpack_public_path__ + "static/media/page19.94791242.jpg";